<template>
  <div class="base-input-wrapper">
    <label v-if="label" :for="inputId" class="base-input-label">
      {{ label }}
    </label>
    <input
      :id="inputId"
      :type="type"
      :value="modelValue"
      :placeholder="placeholder"
      :disabled="disabled"
      :required="required"
      class="base-input"
      @input="$emit('update:modelValue', $event.target.value)"
    />
    <span v-if="error" class="base-input-error">{{ error }}</span>
  </div>
</template>

<script>
export default {
  name: 'BaseInput',
  props: {
    modelValue: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'text'
    },
    label: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    },
    error: {
      type: String,
      default: ''
    }
  },
  emits: ['update:modelValue'],
  computed: {
    inputId() {
      return `input-${Math.random().toString(36).substr(2, 9)}`
    }
  }
}
</script>

<style scoped>
.base-input-wrapper {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-xs, 4px);
  width: 100%;
}

.base-input-label {
  font-size: var(--font-size-sm, 14px);
  font-weight: 500;
  color: var(--color-text-primary, #fff);
}

.base-input {
  width: 100%;
  padding: var(--spacing-sm, 8px) var(--spacing-md, 12px);
  font-size: var(--font-size-base, 16px);
  font-family: inherit;
  color: var(--color-text-primary, #fff);
  background: var(--color-bg-secondary, rgba(255, 255, 255, 0.1));
  border: 2px solid var(--color-border, rgba(255, 255, 255, 0.2));
  border-radius: var(--radius-md, 8px);
  outline: none;
  transition: all 0.2s ease;
}

.base-input:focus {
  border-color: var(--color-accent, #00d4aa);
  background: var(--color-bg-card, rgba(255, 255, 255, 0.05));
}

.base-input:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.base-input::placeholder {
  color: var(--color-text-secondary, rgba(255, 255, 255, 0.5));
}

.base-input-error {
  font-size: var(--font-size-xs, 12px);
  color: var(--color-error, #ff4444);
  margin-top: -4px;
}
</style>

